export const ar = {
  // Login Page
  welcomeMessage: 'مرحباً بك في',
  welcomeEmoji: '👋🏻',
  loginSubtitle: 'يرجى تسجيل الدخول إلى حسابك وبدء المغامرة',
  emailOrUsername: 'البريد الإلكتروني أو اسم المستخدم',
  emailPlaceholder: 'أدخل بريدك الإلكتروني أو اسم المستخدم',
  password: 'كلمة المرور',
  passwordPlaceholder: '············',
  rememberMe: 'تذكرني',
  forgotPassword: 'نسيت كلمة المرور؟',
  login: 'تسجيل الدخول',
  loggingIn: 'تسجيل الدخول...',
  newUser: 'جديد على منصتنا؟',
  createAccount: 'إنشاء حساب',
  or: 'أو',
  characterImage: 'صورة الشخصية',
  mask: 'القناع',

  // Navigation
  home: 'الرئيسية',
  about: 'حول',
  inbox: 'صندوق الرسائل',
  assistants: 'المساعدون',
  knowledgeBases: 'قواعد المعرفة',
  personalAssistant: 'المساعد الشخصي',

  // User Dropdown
  userAlt: 'جون دو',
  userName: 'جون دو',
  userEmail: 'admin@vuexy.com',
  myProfile: 'ملفي الشخصي',
  settings: 'الإعدادات',
  pricing: 'التسعير',
  faq: 'الأسئلة الشائعة',
  logout: 'تسجيل الخروج',

  // Mode Dropdown
  lightMode: 'فاتح',
  darkMode: 'داكن',
  systemMode: 'النظام',
  modeTooltip: 'الوضع',

  // Footer
  copyrightText: 'مصنوع بـ',
  copyrightBy: 'بواسطة',
  companyName: 'NaqshAVA',
  licenseLink: 'الترخيص',
  moreThemesLink: 'المزيد من القوالب',
  documentationLink: 'التوثيق',
  supportLink: 'الدعم',

  // 404 Page
  pageNotFoundTitle: 'الصفحة غير موجودة ⚠️',
  pageNotFoundMessage: 'لم نتمكن من العثور على الصفحة التي تبحث عنها.',
  backToHome: 'العودة للرئيسية',
  notFoundImageAlt: 'صورة خطأ 404',

  // Dashboard Pages
  homePage: 'الصفحة الرئيسية!',
  aboutPage: 'صفحة حول!',

  // Register Page
  registerTitle: 'تبدأ المغامرة هنا 🚀',
  registerSubtitle: 'اجعل إدارة تطبيقك سهلة وممتعة!',
  username: 'اسم المستخدم',
  usernamePlaceholder: 'أدخل اسم المستخدم',
  registerEmail: 'البريد الإلكتروني',
  registerEmailPlaceholder: 'أدخل بريدك الإلكتروني',
  agreeToTerms: 'أوافق على',
  privacyPolicyTerms: 'سياسة الخصوصية والشروط',
  signUp: 'إنشاء حساب',
  alreadyHaveAccount: 'لديك حساب بالفعل؟',
  signInInstead: 'تسجيل الدخول بدلاً من ذلك',
  content: 'المحتوى',

  // Validation Messages
  usernameMinLength: 'يجب أن يكون اسم المستخدم 3 أحرف على الأقل',
  usernameMaxLength: 'يجب أن يكون اسم المستخدم أقل من 20 حرفاً',
  emailRequired: 'البريد الإلكتروني مطلوب',
  emailInvalid: 'يرجى إدخال بريد إلكتروني صحيح',
  passwordMaxLength: 'يجب أن تكون كلمة المرور أقل من 50 حرفاً',
  agreeToTermsRequired: 'يجب الموافقة على الشروط والأحكام',
  passwordMinLength: 'يجب أن تكون كلمة المرور تحتوي على الأقل 8 أحرف.',
  passwordMustContainUppercase: 'يجب أن تحتوي كلمة المرور على حروف إنجليزية كبيرة.',
  passwordMustContainLowercase: 'يجب أن تحتوي كلمة المرور على حروف إنجليزية صغيرة.',
  passwordMustContainNumber: 'يجب أن تحتوي كلمة المرور على رقم واحد على الأقل.',
  passwordMustContainSpecialChar: 'يجب أن تحتوي كلمة المرور على رمز خاص واحد على الأقل مثل @$&.',
  questionRequired: 'السؤال مطلوب',
  answerRequired: 'الإجابة مطلوبة',
  messageCannotBeEmpty: 'لا يمكن أن تكون الرسالة فارغة',
  titleRequired: 'العنوان مطلوب',
  knowledgeBaseRequired: 'يرجى اختيار قاعدة معرفة',
  descriptionRequired: 'الوصف مطلوب',
  linkRequired: 'الرابط مطلوب',
  atLeastOneQuestionRequired: 'أضف سؤالاً واحداً على الأقل',
  fileRequired: 'الملف مطلوب',

  // Register Page Metadata
  registerPageTitle: 'إنشاء حساب',
  registerPageDescription: 'أنشئ حسابك وابدأ المغامرة',

  // Personal Assistant Page Metadata
  personalAssistantPageTitle: 'المساعد الشخصي',
  personalAssistantPageDescription: 'مساعدك الشخصي الذكي لمساعدتك في المهام اليومية وتقديم التوصيات الذكية',

  // Metadata
  metadataTitle: 'آینو - قالب لوحة تحكم إدارية Next.js مع MUI',
  metadataDescription:
    'آینو - قالب لوحة تحكم إدارية Next.js مع MUI - القالب الأكثر ملاءمة للمطورين وقابلية التخصيص المبني على MUI v5.',

  // Personal Assistant Feature
  startNewChat: 'بدء محادثة جديدة',
  searchContacts: 'البحث في جهات الاتصال',
  selectContactToStart: 'اختر جهة اتصال لبدء المحادثة.',
  status: 'الحالة',
  online: 'متصل',
  away: 'غائب',
  doNotDisturb: 'عدم الإزعاج',
  offline: 'غير متصل',
  twoStepVerification: 'التحقق بخطوتين',
  notification: 'الإشعارات',
  inviteFriends: 'دعوة الأصدقاء',
  deleteAccount: 'حذف الحساب',
  typeAMessage: 'اكتب رسالة',
  chooseCollection: 'اختر قاعدة المعرفة الخاصة بك',
  send: 'إرسال',
  selectContact: 'اختر جهة الاتصال',
  action: 'إجراء',
  deleteConfirm: 'هل أنت متأكد أنك تريد حذف هذا العنصر؟',
  yesDelete: 'نعم، احذف',
  cancel: 'إلغاء',
  apiKey: 'مفتاح API',
  baseUrl: 'الرابط الأساسي',
  showSource: 'عرض المصادر',
  apiKeyRequired: 'مفتاح API مطلوب',
  baseUrlRequired: 'عنوان URL الأساسي مطلوب',
  invalidUrl: 'يجب أن يكون عنوان URL صالحًا',
  atLeastOneFieldRequired: 'مطلوب حقل واحد على الأقل',
  apiError: 'فشل تحديث الإعدادات',
  error: 'خطأ',
  balance: 'الرصيد',
  yourBalance: 'رصيدك:',
  passwordsMustNotMatch: 'يجب ألا تكون كلمة المرور الجديدة مثل كلمة المرور الحالية',
  passwordsMustMatch: 'يجب أن تكون كلمة المرور وتأكيدها متطابقين',
  changePassword: 'تغيير كلمة المرور',
  currentPassword: 'كلمة المرور الحالية',
  repeatPassword: 'أعد إدخال كلمة المرور',
  name: 'الاسم',
  PublishAssistant: 'نشر المساعد',
  Step1: 'لإضافة هذا المساعد إلى موقعك، انسخ والصق الكود التالي داخل',
  BodyTag: '<body>',
  Step1End: 'في ملف HTML الخاص بك.',
  Step2: 'بعد الإضافة، سيتم تحميل المساعد تلقائيًا على صفحتك وسيكون جاهزًا للتفاعل مع المستخدمين.',
  Step3: 'للحصول على أفضل أداء، يمكنك وضعه في أسفل HTML الخاص بك (قبل وسم الإغلاق',
  BodyTagEnd: '</body>',
  Step3End: ').',
  agentWelcomeMessage: 'رسالة الترحيب',
  collectionTitle: 'عنوان المجموعة',
  color: 'اللون',
  logo: 'الشعار',
  avatar: 'الصورة الرمزية',
  save: 'حفظ',
  welcomeMessageMin: 'رسالة الترحيب يجب أن تحتوي على ٥ أحرف على الأقل',
  collectionTitleMin: 'عنوان المجموعة يجب أن يحتوي على حرفين على الأقل',
  colorInvalid: 'تنسيق اللون غير صالح',
  reset: 'إعادة تعيين',
  savedSuccessfully: 'تم الحفظ بنجاح',
  saveFailed: 'فشل الحفظ',
  customize: 'تخصيص',
  publish: 'نشر',
  addAgent: 'إضافة مساعد',
  collection: 'المجموعة',
  promptTemplate: 'نموذج المطالبة',
  view: 'عرض',
  na: 'غير متوفر',
  agentName: 'اسم المساعد',
  isPreviouslyUsedPassword: 'يرجى اختيار كلمة مرور أخرى. لقد استخدمت هذه الكلمة من قبل وهي مكررة.',
  somethingWentWrong: 'حدث خطأ ما، يرجى المحاولة مرة أخرى لاحقًا.',
  invalidEmailOrPassword: 'البريد الإلكتروني أو كلمة المرور غير صحيحة.',
  KnowledgeBaseSource: 'مصدر قاعدة المعرفة',

  //menu

  chatBot: 'روبوت الدردشة',
  Agent: 'الوكيل',
  UnAnsweredQuestion: 'الأسئلة غير المجابة',
  PrivateRag: 'المساعد الخاص',
  'Personal Assistant': 'المساعد الشخصي',
  Setting: 'الإعدادات',
  ContentCreator: 'منشئ المحتوى',
  Inbox: 'صندوق الوارد',
  Token: 'رمز',
  KnowledgeBase: 'قاعدة المعرفة',
  profile: 'الملف الشخصي',
  firstName: 'الاسم الأول',
  lastName: 'اسم العائلة',
  phoneNumber: 'رقم الهاتف',
  phoneNumberInvalid: 'رقم هاتف غير صالح',
  countryCodeLabel: 'رمز الدولة',
  countryCodeHelper: 'اختر رمز الاتصال الدولي',
  countryIran: 'إيران',
  countryCanada: 'كندا',
  countryUnitedStates: 'الولايات المتحدة',
  countryUnitedKingdom: 'المملكة المتحدة',
  countryGermany: 'ألمانيا',
  countryFrance: 'فرنسا',
  countryJapan: 'اليابان',
  allowedFileTypes: 'JPG أو GIF أو PNG مسموح.',
  fileSizeLimit: 'يجب أن يكون حجم الملف أقل من ۸۰۰ كيلوبايت.',
  uploadNewPhoto: 'تحميل صورة جديدة',
  unansweredQuestions: 'الأسئلة غير المجابة',
  noUnansweredQuestions: 'لا توجد أسئلة غير مجابة',
  writeAnswerOfFollowingQuestion: 'اكتب إجابة السؤال التالي:',
  pleaseEnterDesiredAnswer: 'يرجى إدخال الإجابة المطلوبة',
  Answered: 'تم الرد',

  //shared
  headerTitle: 'عنوان الرأس',
  headerBackground: 'خلفية الرأس',
  messageTitle: 'عنوان الرسالة',
  messageTextColor: 'لون نص الرسالة',
  messageBackground: 'خلفية الرسالة',
  footerBackground: 'خلفية التذييل',
  chatBackground: 'خلفية الدردشة',
  floatingButtonPosition: 'موضع الزر العائم',
  floatingButtonIcon: 'أيقونة الزر العائم',
  shouldUseAI: 'استخدام الذكاء الاصطناعي',
  shouldUseAIHint: 'عند تعطيل هذا الخيار، ستكون مسؤولاً عن الرد على رسائل الدعم.',
  buttonColor: 'لون الزر',
  bottomLeft: 'أسفل اليسار',
  bottomRight: 'أسفل اليمين',
  acceptableFormatsForImage: 'الصيغ المقبولة: jpg، jpeg، png',
  imageFile: 'ملف الصورة',

  //transactions
  goToPayment: 'الانتقال إلى الدفع',
  price: 'المبلغ',
  continuePayment: 'المتابعة إلى الدفع',
  amountMustBeGreaterThan100000: 'يجب أن يكون المبلغ أكبر من ۱،۰۰۰،۰۰۰',
  selectPackageFirst: 'يرجى اختيار حزمة أولاً',
  recentTransactions: 'المعاملات الأخيرة',
  yourLatestFinancialActivities: 'أحدث أنشطتك المالية',
  newest: 'الأحدث',
  oldest: 'الأقدم',
  latest: 'آخر',
  noRecentTransactionsFound: 'لم يتم العثور على معاملات حديثة.',
  transactionDetails: 'تفاصيل المعاملة',
  share: 'مشاركة',
  export: 'تصدير',
  paymentSuccessfullyCompleted: 'تمت العملية بنجاح',
  fundsTransferredSecurely: 'تم تحويل الأموال بأمان',
  paymentPending: 'الدفعة معلقة',
  paymentIsPending: 'دفعتك قيد الانتظار!',
  paymentUnsuccessful: 'فشل الدفع',
  fundsNotTransferred: 'لم يتم تحويل الأموال',
  userInformation: 'معلومات المستخدم',
  cardDeposit: 'إيداع البطاقة',
  sourceCardNumber: 'رقم البطاقة المصدر',
  destinationCardNumber: 'رقم البطاقة الوجهة',
  paymentProvider: 'مزود الدفع',
  transactionId: 'معرّف المعاملة',
  referenceNumber: 'رقم المرجع',
  explanation: 'توضيح',
  chatbotChargeMessage: 'تم فرض هذه الرسوم لطرح السؤال التالي على الروبوت:',
  currentBalanceAfterTransaction: 'الرصيد الحالي بعد المعاملة',
  date: 'تاريخ',
  wallet: 'محفظة',
  chargeYourAccount: 'شحن حسابك',
  totalBalance: 'الرصيد الكلي',
  BadUserNameError: 'اسم المستخدم الذي تم إدخاله غير صالح.',
  DuplicateUserName: 'اسم المستخدم مستخدم بالفعل.',
  DuplicateEmail: 'اسم المستخدم مستخدم بالفعل.',
  aiModelRequired: 'يرجى اختيار نموذج الذكاء الاصطناعي.',
  aiModel: 'نموذج الذكاء الاصطناعي',
  backToWallet: 'العودة إلى المحفظة',

  filters: 'الفلاتر',
  loading: 'جار التحميل...',
  agent: 'الوكيل',
  agentPlaceholder: 'اختر الوكيل',
  statusPlaceholder: 'اختر الحالة',
  openChat: 'الدردشات المفتوحة',
  closeChat: 'الدردشات المغلقة',
  humanSupport: 'دعم بشري',
  apply: 'تطبيق',
  connectHumanSupport: 'الاتصال بالدعم البشري',
  all: 'الكلّ',
  seeConversation: 'عرض المحادثة',
  noData: 'لا توجد بيانات',
  agentPageTitle: 'تفاصيل المساعد',
  agentPageDesc: 'عرض التفاصيل الكاملة للمساعد الشخصي',
  inboxPageDesc: 'عرض الرسائل والإشعارات الواردة الخاصة بك',
  unansweredQuestionsDesc: 'عرض جميع الأسئلة غير المجابة من المستخدمين وإدارتها',
  fa: 'مشاهده تمام سوالات پاسخ داده نشده کاربران و مدیریت آنها',
  fr: 'Voir toutes les questions non répondues des utilisateurs et les gérer efficacement',
  PaymentResultTitle: 'فاتورة',
  PaymentResultDescription: 'تمت معالجة نتيجة الدفع الخاصة بك. يمكنك عرض جميع تفاصيل العملية في هذه الصفحة.',
  notEnoughBalance: 'رصيد غير كافٍ',

  // Error Messages
  insufficientBalance: 'رصيد غير كافٍ',
  pleaseRechargeYourAccount: 'رصيد حسابك منخفض جداً. يرجى إعادة الشحن لمواصلة استخدام الخدمة.',
  recharge: 'إعادة الشحن الآن',
  networkError: 'خطأ في الشبكة',
  checkYourConnection: 'يرجى التحقق من اتصالك بالإنترنت والمحاولة مرة أخرى.',
  errorOccurred: 'حدث خطأ',
  pleaseTryAgain: 'حدث خطأ ما. يرجى المحاولة مرة أخرى لاحقاً.',

  //packages
  starterPlan: 'خطة البداية',
  growthPlan: 'خطة النمو',
  professionalPlan: 'الخطة الاحترافية',
  starterPlanDesc: '١٬٠٠٠٬٠٠٠ تومان',
  growthPlanDesc: 'اشحن حسابك بـ ٤٬٥٠٠٬٠٠٠ تومان واحصل على رصيد بقيمة ٥٬٠٠٠٬٠٠٠ تومان!',
  professionalPlanDesc: 'اشحن حسابك بـ ٨٬٠٠٠٬٠٠٠ تومان واحصل على رصيد بقيمة ١٠٬٠٠٠٬٠٠٠ تومان!',
  starterPlanFeature1: 'الوصول إلى جميع ميزات آينو',
  starterPlanFeature2: 'رصيد قابل للاستخدام في Private RAG و Chatbot و Content Creator',
  starterPlanFeature3: 'مناسب للاختبار والمشاريع الصغيرة أو الفرق الناشئة',
  growthPlanFeature1: 'الوصول إلى جميع ميزات آينو',
  growthPlanFeature2: 'مناسب للاستخدام الجماعي',
  growthPlanFeature3: 'توفير بنسبة ١٠٪ مقارنة بخطة البداية',
  professionalPlanFeature1: 'الوصول إلى جميع ميزات آينو',
  professionalPlanFeature2: 'كفاءة اقتصادية واستقرار في الاستخدام',
  professionalPlanFeature3: 'مناسب للمشاريع الكبيرة وطويلة الأمد',

  // Error Handler
  accessDenied: 'تم رفض الوصول',
  noAccessToResource: 'ليس لديك إذن للوصول إلى هذا المورد.',
  ok: 'حسنًا',
  close: 'إغلاق'
}
